<template>
  <div
    class="frisbuy-sr-navigation-button"
    :class="[
      `frisbuy-sr-navigation-button--${direction}`,
      {
        'frisbuy-to-hide': isHidden,
        'frisbuy-disabled': isDisabled,
      },
    ]"
    @click="$emit('click')"
  >
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44 36.586L32.708 25.294 32 24.587l-.706.707-11.292 11.292L21.416 38 32 27.415 42.587 38 44 36.586z"
        fill="#262626"
      />
    </svg>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-sr-navigation-button {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  transition: opacity 0.2s, transform 0.3s, height 0.2s;
  cursor: pointer;

  &.frisbuy-to-hide {
    opacity: 0;
    height: 0;
    pointer-events: none;
  }

  &.frisbuy-disabled {
    opacity: 0.1;
    pointer-events: none;
  }

  &:hover {
    opacity: 0.8;
  }

  &--top {
    transform: rotate(0);
  }
  &--right {
    transform: rotate(0.25turn);
  }
  &--bottom {
    transform: rotate(0.5turn);
  }
  &--left {
    transform: rotate(-0.25turn);
  }

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },

  props: {
    direction: {
      type: String,
      require: false,
      default: "top",
      validator: (value) => ["top", "right", "bottom", "left"].includes(value),
    },

    isHidden: {
      type: Boolean,
      require: false,
      default: false,
    },

    isDisabled: {
      type: Boolean,
      require: false,
      default: false,
    },
  },

  emits: ["click"],
};
</script>
